<template>
  <svg :class="svgClass" class="svg-icon" aria-hidden="true">
    <use :xlink:href="iconName"></use>
  </svg>
</template>

<script>
  import { computed } from 'vue'
  export default {
    name: 'icon-svg',
    props: {
      iconClass: {
        type: String,
      },
      name: {
        type: String,
        required: true,
      },
    },
    setup(props) {
      return {
        iconName: computed(() => `#icon-${props.name}`),
        svgClass: computed(() => {
          if (props.className) {
            return 'svg-icon ' + props.className
          } else {
            return 'svg-icon'
          }
        }),
      }
    },
  }
</script>

<style>
  .svg-icon {
    width: 1em;
    height: 1em;
    vertical-align: -0.15em;
    fill: currentColor;
    overflow: hidden;
  }
</style>
